module.exports = __webpack_public_path__ + "img/pitcairnislands.8860ceb4.svg";